<script setup>
import { computed } from "vue";

const props = defineProps({
  open: { type: Boolean, default: false },
});

const emit = defineEmits(["close", "navigate", "logout"]);

const menuClass = computed(() => (props.open ? "menu open" : "menu"));

const nav = (path) => emit("navigate", path);
</script>

<template>
  <div v-if="open" class="overlay" @click="emit('close')"></div>

  <section :class="menuClass" @click.stop>
    <header class="menu-header">
      <div class="title">시작메뉴</div>
      <button class="x" @click="emit('close')">✕</button>
    </header>

    <div class="menu-body">
      <button class="item" @click="nav('/app')">
        <span class="icon">🏠</span>
        <span>홈</span>
      </button>

      <button class="item" @click="nav('/app/selling')">
        <span class="icon">🏢</span>
        <span>실거래가</span>
      </button>

      <button class="item" @click="nav('/app/top')">
        <span class="icon">🏢</span>
        <span>Top30</span>
      </button>

      <button class="item" @click="nav('/app/trend')">
        <span class="icon">📈</span>
        <span>실거래 추이</span>
      </button>

      <hr class="sep" />

      <button class="item danger" @click="emit('logout')">
        <span class="icon">⎋</span>
        <span>로그아웃</span>
      </button>
    </div>
  </section>
</template>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 10;
}

.menu {
  position: fixed;
  left: 10px;
  /* offset above the taskbar and any device safe-area (nav bar) */
  bottom: calc(58px + env(safe-area-inset-bottom, 0px));
  width: min(320px, calc(100% - 20px));
  border-radius: 14px;
  background: rgba(24, 32, 50, 0.92);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
  transform: translateY(12px);
  opacity: 0;
  pointer-events: none;
  transition: 0.15s ease;
  z-index: 30;
}
.menu.open {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}
.menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 12px 6px;
}
.title {
  font-weight: 800;
  letter-spacing: 0.2px;
}
.x {
  border: 0;
  background: transparent;
  color: #eaf2ff;
  cursor: pointer;
  opacity: 0.8;
}
.menu-body {
  padding: 8px 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #eaf2ff;
  cursor: pointer;
  text-align: left;
}
.item:hover {
  background: rgba(255, 255, 255, 0.1);
}
.icon {
  width: 22px;
  text-align: center;
}
.sep {
  border: 0;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 6px 4px;
}
.danger {
  border-color: rgba(255, 120, 120, 0.25);
}
.danger:hover {
  background: rgba(255, 120, 120, 0.12);
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .menu {
    width: min(80vw, calc(100% - 20px));
    bottom: calc(66px + env(safe-area-inset-bottom, 0px));
  }

  .menu-header {
    padding: 10px 10px 4px;
  }

  .title {
    font-size: 16px;
  }

  .x {
    font-size: 20px;
  }

  .menu-body {
    gap: 4px;
    padding: 6px 8px 10px;
  }

  .item {
    padding: 12px 10px;
    gap: 12px;
    font-size: 14px;
    min-height: 44px;
  }

  .icon {
    width: 24px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .menu {
    left: 6px;
    right: 6px;
    width: auto;
    max-height: 60vh;
    bottom: calc(64px + env(safe-area-inset-bottom, 0px));
  }

  .menu-header {
    padding: 8px 10px 4px;
  }

  .title {
    font-size: 14px;
    font-weight: 700;
  }

  .menu-body {
    gap: 3px;
    padding: 4px 6px 8px;
    max-height: 50vh;
    overflow-y: auto;
  }

  .item {
    padding: 12px 10px;
    border-radius: 10px;
    gap: 12px;
    font-size: 13px;
  }

  .icon {
    width: 20px;
    font-size: 16px;
  }

  .sep {
    margin: 4px 0;
  }
}
</style>
